import { readCache, storeCache } from './api'
import type { TodayPayload } from './types'

// Today's saved copy of one day, written only by Today (screens/today.ts): the five-day window save and the
// single-day read both come through here. Each copy carries the number the day was downloaded at (GET /api/today
// `revs`, migration 0038), and a copy is never replaced by an OLDER one: a single-day read that set off before
// the window save can arrive after it, and used to put the older jobs back over the newer ones while the phone told
// the server it held the newer (Astra, 1 Oct: told rev 11, holding rev 10, so the owner saw no warning while the
// phone had the old address). Kept here, not in api.ts's general saved-copy writer, because only Today's copies
// have numbers.

export interface DayCopy {
  // The number the phone now holds for the day, or null when it holds no numbered copy (nothing saved, an older
  // app's copy, or storage failed).
  rev: number | null
  // A newer copy already on the phone that was kept instead of this answer: show that one.
  newer: TodayPayload | null
}

const revOf = (p: TodayPayload | null | undefined, date: string): number | null => {
  const r = p?.revs && Object.hasOwn(p.revs, date) ? p.revs[date] : undefined
  return typeof r === 'number' && Number.isFinite(r) ? r : null
}

export function saveDayCopy(key: string, day: TodayPayload, date: string): DayCopy {
  const incoming = revOf(day, date)
  const held = readCache<TodayPayload>(key)?.data ?? null
  const heldRev = revOf(held, date)
  if (incoming !== null && heldRev !== null && incoming < heldRev) return { rev: heldRev, newer: held }
  return { rev: storeCache(key, day) ? incoming : null, newer: null }
}
